export interface BasicWord {
    lemma: string
    translation: string
}

export interface BasicWordWithId extends BasicWord {
    wordId: number
}

export interface ExampleSentence {
    sentence: string
    translation: string
}

export enum PartOfSpeech {
    Noun = "Noun",
    Verb = "Verb",
    Adjective = "Adjective",
    Adverb = "Adverb",
    Pronoun = "Pronoun",
    Preposition = "Preposition",
    Conjunction = "Conjunction",
    Interjection = "Interjection",
    Article = "Article",
    Numeral = "Numeral",
    Particle = "Particle",
    Expression = "Expression",
    Unknown = "",
}

export type GeneralWordResources<TExtension = object> = {
    lemma: string | null
    sentence: string | null
    image: string | null
} & Partial<TExtension>

export interface Word<TMorphology = unknown> {
    lemma: string
    translations: string[]
    exampleSentences: ExampleSentence[]
    partOfSpeech: PartOfSpeech
    userTranslations?: string[]
    morphology: TMorphology
    resources: GeneralWordResources | null
}

export interface WordWithId extends Word {
    wordId: string
}

export interface StagedWord extends WordWithId {
    stage: number
}

export interface WordWithSound extends WordWithId {
    sound: HTMLAudioElement | null
}

export interface WordWithDuplicates extends WordWithId {
    ignoreLemmas: string[]
    ignoreTranslations: string[]
}

export interface WordForReview extends WordWithDuplicates {
    phase: number
    sound: HTMLAudioElement | null
    fails: number
    failedPosts: number
    stage?: number
    state?: string
}

export interface WordFullInfo extends WordWithId {
    learnedTime: Date
    nextReviewTime: Date
    stage?: number
    synonyms: BasicWordWithId[]
    unit: string
    topic: string
}

export type BasicWordWithIdList = BasicWordWithId[]

export type WordList = Word[]

export type WordWithIdList = WordWithId[]